import React, { useState, useEffect } from 'react';
import * as S from './TemplatesModal.styles';
import { getTemplates, Template } from '../../../entities/template/api/templateApi';

interface TemplatesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInsert: (content: string) => void;
}

export const TemplatesModal: React.FC<TemplatesModalProps> = ({
  isOpen,
  onClose,
  onInsert,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadTemplates();
    }
  }, [isOpen, searchQuery]);

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const data = await getTemplates(searchQuery);
      setTemplates(data);
    } catch (error) {
      console.error('Ошибка загрузки шаблонов:', error);
      setTemplates([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredTemplates = templates;

  const handleSelect = (template: Template) => {
    setSelectedTemplate(template);
  };

  const handleInsert = () => {
    if (selectedTemplate) {
      onInsert(selectedTemplate.content);
      onClose();
      setSelectedTemplate(null);
      setSearchQuery('');
    }
  };

  if (!isOpen) return null;

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <S.ModalTitle>Шаблоны ответов</S.ModalTitle>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
        </S.ModalHeader>

        <S.SearchInput
          type="text"
          placeholder="Поиск по названию или содержимому шаблона..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        <S.TemplatesContainer>
          <S.TemplatesList>
            {loading ? (
              <S.EmptyText>Загрузка...</S.EmptyText>
            ) : filteredTemplates.length === 0 ? (
              <S.EmptyText>Шаблоны не найдены</S.EmptyText>
            ) : (
              filteredTemplates.map(template => (
                <S.TemplateItem
                  key={template.id}
                  $selected={selectedTemplate?.id === template.id}
                  onClick={() => handleSelect(template)}
                >
                  <S.TemplateName>{template.name}</S.TemplateName>
                  <S.TemplatePreview>{template.content}</S.TemplatePreview>
                </S.TemplateItem>
              ))
            )}
          </S.TemplatesList>

          {selectedTemplate && (
            <S.TemplatePreviewPanel>
              <S.PreviewTitle>Предпросмотр:</S.PreviewTitle>
              <S.PreviewContent>{selectedTemplate.content}</S.PreviewContent>
              <S.InsertButton onClick={handleInsert}>
                Вставить в чат
              </S.InsertButton>
            </S.TemplatePreviewPanel>
          )}
        </S.TemplatesContainer>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};

